import { createValidImageURL } from "data/Utils";
import React from "react";
import * as SITE_SETTINGS from "content/site/config.json";

type State = {
  hover: boolean;
};

class Footer extends React.Component<{}, State> {
  state = {
    hover: false,
  };

  render() {
    // const contactDetails = CONTACT_DETAILS;
    const config = SITE_SETTINGS;

    return (
      <section className="mt-40 flex relative pb-5 pt-10 min-h-[130px] items-center justify-center bg-accent text-whiteColor">
        <h6 className=" absolute top-[-3rem] text-center w-full lg:w-auto lg:right-10 text-accent bg-pink">
          Website made and maintained by{" "}
          <a className=" font-bold" href="https://www.tomfranklin.dev/">
            Tom Franklin
          </a>{" "}
        </h6>
        <div className="flex flex-col gap-5 lg:flex-row justify-between w-full items-center pl-5 pr-5">
          {/* <h5 className="text-center mt-10">
            © {new Date().getFullYear()} Noomi Studios
          </h5> */}
          <img
            src={createValidImageURL(config.logo)}
            alt="Noomi Studios Logo"
          />
          <div className="flex flex-col justify-center">
            <p className="flex gap-10 text-center h-10 text-whiteColor mt-5 justify-center">
              <a className="text-whiteColor font-sylexiad" href="/privacy">
                Privacy Policy
              </a>
              <a className="text-whiteColor font-sylexiad" href="/contact">
                Contact
              </a>
            </p>
            <h6 className="text-center font-sylexiad">
              Sono and Su® is a registered trademark of Noomi Studios
            </h6>
          </div>

          <div className=" bg-pink flex flex-col justify-center">
            <p className="mr-auto ml-auto lg:mr-0 mt-2 text-[12px] opacity-[0.6]">
              © {new Date().getFullYear()} Noomi Studios
            </p>
          </div>
        </div>
      </section>
    );
  }
}

export default Footer;
